import React, { useEffect, useState } from 'react';
import TitleMain from "../../components/Title/TitleMain";
import {useUser} from "../../contexts/UserContext";
import {Link, useLocation} from "react-router-dom";
import styles from './UserStatusPage.module.css';
import FieldUpload from "../../components/Field/FieldUpload";
import {
    getJustificatifsFiles,
    getJustificatifsTypesObligatoires
} from "../../services/FileService";
import Routing from "../../services/routing";

function UserStatusPage({  }) {
    const { user } = useUser();
    const [title, setTitle] = useState("Bonjour ");
    const [justificatifs, setJustificatifs] = useState([]);
    const [justificatifsTypes, setJustificatifsTypes] = useState([]);
    const location = useLocation();

    useEffect(() => {
        if (!user) return;

        setTitle("Bonjour " + user.prenom + " " + user.nom);

        const fetchJustificatifsTypes = async () => {
            try {
                const response= await getJustificatifsTypesObligatoires();
                setJustificatifsTypes(response);
            } catch (error) {
                console.error('Erreur lors de la récupération des justificatifs types:', error);
            }
        };

        const fetchJustificatifs = async () => {
            try {
                const response = await getJustificatifsFiles();
                setJustificatifs(response);
            } catch (error) {
                console.error('Erreur lors de la récupération des justificatifs:', error);
            }
        };

        fetchJustificatifsTypes();
        fetchJustificatifs();
    }, [user]);

    const renderedFieldUploads = justificatifsTypes.map(justType => {
        const justificatif = justificatifs.find(just => {
            return just.justificatifType && just.justificatifType.justId === justType.justId;
        });

        return (
            <FieldUpload
                key={justType.justId}
                label={justType.justLabel}
                name={`type${justType.justId}_file`}
                value={justificatif}
                data={{justificatifType: justType.justId, justificatifActif: justType.justActif, justificatifObligatoire: justType.justObligatoire}}
                onSuccess={() => { window.location.reload(); }}
            />
        );
    });

    const renderByUserStatus = () => {
        if (user.status !== null) {
            switch (user.status) {
                case -2: // attente_justificatif
                    return (
                        <div>
                            <p>On est sur la bonne voie !</p>
                            <p>Un justificatif et vous êtes en piste pour votre première séance. 🏋️‍♂️ ️️</p>

                            <div className={styles.filesContent}>
                                { renderedFieldUploads }
                            </div>

                        </div>
                    );
                case -1: // coach_attente_validation_admin
                    return (
                        <div>
                            <p>Bientôt prêt pour l'action !</p>
                            <p>Encore un peu de patience pendant que nos administrateurs valident votre compte 🤸️‍♂️ </p>
                        </div>
                    );
                case 0: // importe
                    return (
                        <div>
                            <p>Cliquez sur le lien reçu par mail pour confirmer votre compte et vous voilà dans la course 🏃‍♂️</p>
                        </div>
                    );
                case 1: // compte_cree
                    return (
                        <div>
                            <p>Bravo, vous êtes sur la ligne de départ ! </p>
                            <p>
                                Quelle sera votre prochaine séance ? 🚴
                            </p>
                            <p>
                                <Link to={Routing.routes.seances} className={styles.lien}>Voir les séances</Link>️
                            </p>
                        </div>
                    );
                case 3: // compte_bloque
                    return (
                        <div>
                            <p>Votre compte a rencontré un souci.</p>
                            <p>Contactez-nous pour remettre les poids sur la barre. 🏋️‍♀️</p>
                        </div>
                    );
                default:
                    return (
                        <div>
                            <p>Bienvenue champion !</p>
                            <p>Prêt à vous surpasser avec nous ? 🏋️‍♀️</p>
                            <p>
                                <Link to={Routing.routes.seances} className={styles.lien}>Voir les séances</Link>️
                            </p>
                        </div>
                    );
            }
        }
    }

    return (
        <div className="content">
            <TitleMain text={title}/>

            <div className={styles.container}>
                {renderByUserStatus()}
            </div>

            <div className="signaler-link-container">
                <Link to={ Routing.generate({
                    route: Routing.routes.report,
                    queryParams: {from: encodeURIComponent(location.pathname + location.search)}
                })} className="link">Signaler un problème</Link>
            </div>
        </div>
    )
}

export default UserStatusPage;
